// app/packages/platform-contract/src/signature/document.schema.ts
//
// Document aggregate — written once per signature save (Stage 4 of the seven-stage
// pipeline). Mirrors design.md §6 (doc-signature-stubs).
import { z } from 'zod';

export const DocumentSchema = z.object({
  documentId: z.string().guid(),
  documentSourceId: z.string().guid(),
  sourceTable: z.string().min(1).max(128),
  documentType: z.string().min(1).max(100),
  documentName: z.string().min(1).max(1000),
  documentDescription: z.string().max(1000).nullable(),
  /** '' sentinel per ADR-7 — un-generated documents (rendered PDF written by follow-on intent). */
  documentPath: z.string(),
  isActive: z.boolean(),
  isDigitallySigned: z.boolean(),
  isManuallySigned: z.boolean(),
  isLink: z.boolean(),
  duplicatedFromDocumentId: z.string().guid().nullable(),
  reportDatasetId: z.number().int().nullable(),
  /** Always set when FormConfiguration drove the save. */
  formConfigurationId: z.string().guid(),
  /** Null for new-document writes; set by post-create hooks in future intents. */
  regeneratedOn: z.string().datetime().nullable(),
});

export type Document = z.infer<typeof DocumentSchema>;
